import {
  GET_CREATOR_METADATA,
  GET_CREATOR_METADATA_LOADING,
} from '../actions/Types'

const initialState = {
  data: null,
  loading: false,
}

export default function CreatorMetadataReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CREATOR_METADATA:
      return {
        ...state,
        data: action.payload,
      }
    case GET_CREATOR_METADATA_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}
